import { ITheme } from "smarthub-common";
import { IProps } from "../props";
import { darcieLightTheme } from "./darcie.light.theme";
import { aliLightTheme } from "./ali.light.theme";

const personalityMapping = {
  Darcie: [darcieLightTheme],
  Ali: [aliLightTheme],
};

export const themes = ({ personality }: IProps): ITheme[] =>
  personalityMapping[personality];
